//@flow
import React from 'react';

import notification from '../../Notification/components/StandardNotification.react';
import Constants from '../../constants';

import type { NotificationProps } from '../../Notification/components/StandardNotification.react';

type NotificationData = {
  discount?:string,
  code?:string,
  qualification?:string,
  credit?:string,
};

type Props = NotificationProps&{
  data:NotificationData,
};

function _shouldRender(props:Props) {
  return props.data.discount || props.data.credit;
}

function _giftCardNotification(notification:NotificationData) {
  return (
    <div>
      <p className="bold black">Gift card redeemed!</p>
      <p className="gray-dark">We&apos;ve added <span className="unlocked-promo">{notification.credit}</span> in credit to your account. It will be automatically applied to your order.</p>
      <p className="text-4">Any unused gift card credit will remain in your account and does not expire.</p>
    </div>
  );
}

function _promoCodeRevealed(notification:NotificationData) {
  return (
    <div>
      <p className="bold black">Promo code revealed!</p>
      <p>Use <span className="gray-dark unlocked-promo">{notification.code}</span> at checkout to get {notification.discount} off your first order.</p>
    </div>
  );
}

function _promoApplied(notification:NotificationData) {
  return (
    <div>
      <p className="bold black">Promotion redeemed!</p>
      <p className="gray-dark">You will automatically receive <span className="unlocked-promo">{notification.discount} off</span> your purchase {notification.qualification}.</p>
    </div>
  );
}

function PromoNotification(props:Props) {
  const notification = props.data;

  if (notification.credit) return _giftCardNotification(notification);
  if (notification.code) return _promoCodeRevealed(notification);
  return _promoApplied(notification);
}

export default notification<{}>(PromoNotification, {
  name: Constants.PROMO_NOTIFICATION,
  className: 'promo-notification',
  shouldRender: _shouldRender,
});
